import { render, staticRenderFns } from "./CarrotQuest.vue?vue&type=template&id=61ea25a8&"
import script from "./CarrotQuest.vue?vue&type=script&lang=js&"
export * from "./CarrotQuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports